package com.stiv_apps.facecutweb.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.stiv_apps.facecutweb.section.MainSection
import com.stiv_apps.facecutweb.util.BackgroundGradient
import com.stiv_apps.facecutweb.util.Theme
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw

@OptIn(DelicateApi::class)
@Page
@Composable
fun HomePage() {
    val breakpoint = rememberBreakpoint()
    val largeBreakpoint = remember(breakpoint) {
        breakpoint > Breakpoint.LG
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Colors.Black)
            .width(100.vw)
            .height(100.vh),
        contentAlignment = Alignment.TopCenter
    ) {
        MainSection(
            breakpoint = breakpoint,
            largeBreakpoint = largeBreakpoint
        )
    }
}